import { SensorsBoxesRepository } from "@/api/Repositories";

export default {
  namespaced: true,
  state: {
    sensors_boxes: [],
    item: {},
    images: [],
    data: [],
  },
  mutations: {
    getSensorsBoxes (state, data) {
      state.sensors_boxes = []
      state.sensors_boxes = data
    },
    getImages (state, data) {
      state.images = []
      state.images = data
    },
    getData (state, data) {
      state.data = []
      state.data = data
    },
    item (state, data) {
      state.item = {}
      state.item = data
    },
  },
  actions: {
    // Get
    getSensorsBoxes ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        SensorsBoxesRepository.getAll(obj)
          .then(response => {
            const data = response.data.data.reverse()
            commit('getSensorsBoxes', data)
            resolve();
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    get ({ commit }, id) {
      return new Promise((resolve, reject) => {
        SensorsBoxesRepository.get(id)
          .then((response) => {
            const data = response.data.data
            commit('item', data)
            resolve(response);
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    getImages ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        SensorsBoxesRepository.getImages(obj)
          .then(response => {
            const data = response.data.data.reverse()
            commit('getImages', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    getData ({ commit }, obj) {
      return new Promise((resolve, reject) => {
        SensorsBoxesRepository.getData(obj)
          .then(response => {
            const data = response.data.data.reverse()
            commit('getData', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    // Actions    
    createSensorsBox (context, sensorsBox) {
      return new Promise((resolve, reject) => {
        SensorsBoxesRepository.create(sensorsBox)
          .then(() => {
            resolve();
          })
          .catch(errorCreate => {
            reject(errorCreate);
          });
      });
    },
    editSensorsBox (context, sensorsBox) {
      return new Promise((resolve, reject) => {
        SensorsBoxesRepository.update(sensorsBox)
          .then(() => {
            resolve();
          }).catch(errorEdit => {
            reject(errorEdit);
          });
      });
    },
    deleteSensorsBox (context, id) {
      return new Promise((resolve, reject) => {
        SensorsBoxesRepository.delete(id)
          .then(() => {
            resolve();
          })
          .catch(errorDelete => {
            reject(errorDelete);
          });
      });
    }
  }
}
